if (!customElements.get('grand-format')) {
  class GrandFormat extends HTMLElement {
    constructor() {
      super();
      this.panels = this.querySelectorAll('.js-grand-format-panel');
      window.initLazyScript(this, this.initLazySection.bind(this));
    }

    initLazySection() {
      const variantPicker = this.closest('.product')?.querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }

      if (this.dataset.currentVariantId) {
        this.setVisiblePanel(this.dataset.currentVariantId);
      }
    }

    setVisiblePanel(variantId) {
      let hasVisiblePanel = false;

      for (const panel of this.panels) {
        const isCurrent = panel.dataset.variantId.toString() === variantId.toString();
        panel.hidden = !isCurrent;
        if (isCurrent) hasVisiblePanel = true;
      }

      this.hidden = !hasVisiblePanel;
    }

    handleVariantChange(event) {
      if (!event.detail.variant) return;
      this.setVisiblePanel(event.detail.variant.id);
    }
  }

  customElements.define('grand-format', GrandFormat);
}
